module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/point_01-d192652106bbd6a6c5dbda8f49008e7e.png";